import { trigger, state, style, transition, animate } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DialogConfirmComponent } from 'src/app/dialog/dialog-confirm/dialog-confirm.component';
import { AppService, GRSSResponse, GRSSUserRoles, ValueIdPair } from 'src/app/_services/app.service';
import { AddGeneralMarketComponent } from './add-general-market/add-general-market.component';
import { AddInstrumentComponent } from './add-instrument/add-instrument.component';
//import moment from 'moment';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { ComponentCanDeactivate } from 'src/app/_guard/pending-changes.guard';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
//import { formatDate } from '@angular/common';
import { AddTestComponent } from './add-test/add-test.component';

@Component({
    selector: 'app-manage-general-markets',
    templateUrl: './manage-general-markets.component.html',
    styleUrls: ['./manage-general-markets.component.css'],
    animations: [
        trigger('slider', [
            state('*', style({
                height: 0
            })),
            state('show', style({
                height: '*'
            })),
            transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
        ])
    ],
    standalone: false
})
export class ManageGeneralMarketsComponent implements OnInit, ComponentCanDeactivate  {

  displayColumns: string[] = ['code', 'description', 'calType', 'term', 'spread', 'actions'];
  dataSource = new MatTableDataSource();
  isSelected = false;


  displayColumnsTests: string[] = ['test', 'enabled', 'verbose', 'actions'];
  dataSourceTests = new MatTableDataSource();
  testslength: number;

  selectedMarket: GeneralMarket;
  selectedMarketTemp: GeneralMarket;

  instrumentsLength: number;
  searchKey: string;
  generalMarkets: ValueIdPair[];

  treeControl = new NestedTreeControl<ContributorListNode>(node => node.children);
  dataSourceTree = new MatTreeNestedDataSource<ContributorListNode>();

  roundings: ValueIdPair[];
  verifications: ValueIdPair[];
  quorums: ValueIdPair[];
  repetitions: ValueIdPair[];
  statuses: ValueIdPair[];
  calculationTypes: ValueIdPair[];
  futuresTypes: ValueIdPair[];
  forwardLookingRates: ValueIdPair[];
  currencies: ValueIdPair[] = [];

  isRepetitionMonthly = false;
  isRepetitionWeekly = false;

  adminRoleName = GRSSUserRoles.Admin;
  complianceRoleName = GRSSUserRoles.Compliance;
  operatorRoleName: string = GRSSUserRoles.Operator;

  paginator: MatPaginator;
  sort: MatSort;


  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(private translate: TranslateService, @Inject('BASE_URL') private baseUrl: string, private http: HttpClient, private dialog: MatDialog, public service: AppService) {
    this.service.SetTranslation('administration/manage-general-markets');
  }

  ngOnInit() {
    this.GetMarkets();
    this.GetListsItems();
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away

    let hasChanges: boolean = false;
    if (JSON.stringify(this.selectedMarket) !== JSON.stringify(this.selectedMarketTemp)) {
      hasChanges = true;
    }

    return !hasChanges;
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /** Gets all the general markets for user*/
  GetMarkets() {
    this.http.get<ValueIdPair[]>(this.baseUrl + 'api/generalMarkets/getMarkets').subscribe(result => {
      this.generalMarkets = result;
    }, error => {
      console.error(error);
    });
  }

  /**
   * Gets the selected market details
   * @param marketId Selected market id
   */
  GetMarket(marketId: string) {
    this.http.get<GeneralMarket>(this.baseUrl + 'api/generalMarkets/getMarket/' + marketId).subscribe(result => {
      this.isSelected = true;
      this.selectedMarket = result;
      this.selectedMarketTemp = JSON.parse(JSON.stringify(result));
      this.UpdateInstrumentTable();

      // this.dataSource.sort = this.sort;
      // this.dataSource.paginator = this.paginator;
      if (this.selectedMarket.contributorIds.length > 0) {
        this.dataSourceTree.data.forEach(node => {
          if (node.children.length > 0) {
            node.children.forEach(innerNode => {
                if (this.selectedMarket.contributorIds.includes(innerNode.id)) {
                  innerNode.checked = true;
                  this.treeControl.expand(node);
                } else {
                  innerNode.checked = false;
                }
            });
          }
        });
      }

      if (this.service.currentUser.userRole === this.complianceRoleName) {
        if (this.displayColumns.includes('actions')) {
          const index = this.displayColumns.indexOf('actions');
          this.displayColumns.splice(index, 1);
        }
      }

      const repetition = this.repetitions.find(x => x.id === this.selectedMarket.listRepetitionId).value;
      this.onChangeRepetition(repetition);

      this.testslength = this.selectedMarket.tests.length;
      this.dataSourceTests = new MatTableDataSource(this.selectedMarket.tests);
    }, error => {
      console.error(error);
    });
  }

  /** Gets all the list items in the general market form */
  GetListsItems() {
    this.http.get<MarketFormLists>(this.baseUrl + 'api/generalMarkets/getListsItems').subscribe(result => {
      this.roundings = result.roundings;
      this.verifications = result.verifications;
      this.quorums = result.quorums;
      this.repetitions = result.repetitions;
      this.calculationTypes = result.calculationTypes;
      this.futuresTypes = result.futuresTypes;
      this.forwardLookingRates = result.forwardLookingRates;
      this.currencies = result.currencies;
      this.dataSourceTree.data = result.contributorslist;
    }, error => {
      console.error(error);
    });
  }

  /**
   *  On change event for general market dropdown
   * @param market selected market
   */
  OnChangeMarket(marketId: string) {
    this.GetMarket(marketId);
  }

  /**
   *  On change event for repetition
   * @param repetition selected repetition
   */
  onChangeRepetition(repetition: string) {
    if (repetition === 'Daily') {
      this.isRepetitionMonthly = false;
      this.isRepetitionWeekly = false;
    } else if (repetition === 'Monthly') {
      this.isRepetitionMonthly = true;
      this.isRepetitionWeekly = false;
    } else if (repetition === 'Weekly') {
      this.isRepetitionMonthly = false;
      this.isRepetitionWeekly = true;
    }
  }

  /** New button event for create a new general market */
  OnCreateMarket() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.position = { top: '5%' };
    this.dialog.open(AddGeneralMarketComponent, dialogConfig).afterClosed().subscribe(res => {
      if (res === 1) {
        this.selectedMarket = null;
        this.selectedMarketTemp = null;
        this.isSelected = false;
        this.GetMarkets();
      }
    });
  }

  /**
 * Updated the selected schedule recipients ids
 * @param id Selected ID
 * @param checked Represents whether checkbox checked or not
 */
  OnClickRecipient(id: string, checked: boolean) {
    if (checked === true) {
      if (this.selectedMarket.contributorIds.length > 0) {
        if (!this.selectedMarket.contributorIds.includes(id)) {
          this.selectedMarket.contributorIds.push(id);
        }
      } else {
        this.selectedMarket.contributorIds.push(id);
      }
    } else {
      if (this.selectedMarket.contributorIds.length > 0) {
        if (this.selectedMarket.contributorIds.includes(id)) {
          const index = this.selectedMarket.contributorIds.indexOf(id, 0);
          this.selectedMarket.contributorIds.splice(index, 1);
        }
      }
    }
  }


  hasChild = (_: number, node: ContributorListNode) => !!node.children && node.children.length > 0;

  /** Delete button event for delete selected general market */
  OnDeleteMarket() {
    if (this.service.currentUser.userRole !== GRSSUserRoles.Operator) {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        disableClose: true,
        data: {
          title: this.translate.instant('Markets.General.Messages.msgHeaderDeleteMarket'),
          message: this.translate.instant('Markets.General.Messages.msgParaDeleteMarket')
        },
        position: { top: '5%' }
      });
      dialogRef.afterClosed().subscribe(res => {
        // Evaluate the users response.
        if (res === true) {
          this.service.showSpinner();
          this.http.delete<GRSSResponse>(this.baseUrl + 'api/generalMarkets/deleteMarket/' + this.selectedMarket.marketId).subscribe(result => {
            if (result.statusCode === 4) {
              this.service.SaveStatus(true, 'Markets.General.Messages.msgHeaderDeleteMarket', result.statusMessage);
            } else {
              if (result.statusCode === 1) {
                this.isSelected = false;
                this.GetMarkets();
              }
              this.service.SaveStatus(false, 'Markets.General.Messages.msgHeaderDeleteMarket', result.statusMessage);
            }
          }, error => {
            console.error(error);
          }).add(() => {
            this.service.hideSpinner();
          });
        }
      });
    }
  }

  /** Save button event for save selected general market */
  OnSaveMarket() {
    const market = this.selectedMarket;
    if (market.listQuorumId !== '' && market.listRepetitionId !== '' && market.listRoundingId !== '' && market.listVerificationId !== '' && market.code !== '' &&
      market.description !== '' && market.repetitionDay !== null && market.quorum !== null && market.contributionStart !== null && market.contributionFinish != null &&
      market.calculationTime !== null && market.overrideFinish !== null && (market.transactional === false || (market.transactional === true && market.currencyId))) {
        if (this.selectedMarket.nextCalculation) {
          const date = new Date(market.nextCalculation);
          // if (momentUtc.isUTC()) {
          //   console.log('it"s utc');
          //  this.selectedMarket.nextCalculation = new Date(Date.UTC(momentUtc.year(), momentUtc.month(), momentUtc.date(), momentUtc.hours(), momentUtc.minutes(), momentUtc.seconds())).toString();
          // }
          this.selectedMarket.nextCalculation = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

        }
        this.service.showSpinner();
        this.http.post<GRSSResponse>(this.baseUrl + 'api/generalMarkets/updateGeneralMarket', this.selectedMarket).subscribe(result => {
          if (result.statusCode === 1) {
            this.service.SaveStatus(false, this.translate.instant('Markets.General.Messages.msgHeaderUpdateMarket'), result.statusMessage, true);
            this.GetMarkets();
            this.OnChangeMarket(this.selectedMarket.marketId);
          } else if (result.statusCode === 4) {
            this.service.SaveStatus(true, 'Markets.General.Messages.msgHeaderUpdateMarket', result.statusMessage);
          } else {
            this.service.SaveStatus(false, this.translate.instant('Markets.General.Messages.msgHeaderUpdateMarket'), result.statusMessage, true);
          }
        }, error => {
          console.error(error);
        }).add(() => {
          this.service.hideSpinner();
        });
    }
  }


  /** applying filter for dataSources */
  ApplyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }

  /** clear and close search user and set to the initial userlist by calling applyfilter */
  OnSearchClear() {
    this.searchKey = '';
    this.ApplyFilter();
  }

  /** Reset the refix time */
  OnClickRefixReset() {
    this.selectedMarket.refixTime = null;
  }

  /** Create button event of instrument */
  OnCreateInstrument() {
    this.service.isUpdateInstrument = false;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    dialogConfig.data = {
      instrument: null,
      calTypes: this.calculationTypes,
      futuresTypes: this.futuresTypes,
      forwardLookingRates: this.forwardLookingRates,
      isTransactional: this.selectedMarket.transactional
    };
    dialogConfig.position = { top: '5%' };
    this.dialog.open(AddInstrumentComponent, dialogConfig).afterClosed().subscribe((res: Instrument) => {
      if (res !== null) {
        this.selectedMarket.instruments.push(res);
        this.UpdateInstrumentTable();
      }
    });
  }

  /**
   *  Edit icon event of a instrument
   * @param instrument Selected instrument
   */
  OnEditInstrument(instrument: Instrument) {
    this.service.isUpdateInstrument = true;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    dialogConfig.position = { top: '5%' };
    dialogConfig.data = {
      instrument: instrument,
      calTypes: this.calculationTypes,
      futuresTypes: this.futuresTypes,
      forwardLookingRates: this.forwardLookingRates,
      isTransactional: this.selectedMarket.transactional
    };
    this.dialog.open(AddInstrumentComponent, dialogConfig).afterClosed().subscribe((res: Instrument) => {
      if (res !== null) {
        const index = this.selectedMarket.instruments.indexOf(instrument, 0);
        this.selectedMarket.instruments.splice(index, 1, res);
        this.UpdateInstrumentTable();
      }
    });
  }

  /**
   * Delete icon event of a instrument
   * @param instrument Selected instrument
   */
  OnDeleteInstrument(instrument: Instrument) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      disableClose: true,
      data: {
        title: this.translate.instant('Markets.General.Messages.msgHeaderDeleteIns'),
        message: this.translate.instant('Markets.General.Messages.msgParaDeleteIns')
      },
      position: { top: '5%' }
    });
    dialogRef.afterClosed().subscribe(result => {
      // Evaluate the users response.
      if (result === true) {
        const index = this.selectedMarket.instruments.indexOf(instrument, 0);
        this.selectedMarket.instruments.splice(index, 1);
        this.UpdateInstrumentTable();
      }
    });
  }

  /** Updating the service account table */
  UpdateInstrumentTable() {
    this.instrumentsLength = this.selectedMarket.instruments.length;
    this.dataSource = new MatTableDataSource(this.selectedMarket.instruments);
  }

  /**
   * Edit event of a test
   * @param test Selected test
   */
  OnEditTest(test: Test) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '40%';
    dialogConfig.position = { top: '5%' };
    dialogConfig.data = test;
    this.dialog.open(AddTestComponent, dialogConfig).afterClosed().subscribe((res: Test) => {
      if (res !== null) {
        const index = this.selectedMarket.tests.indexOf(test, 0);
        this.selectedMarket.tests.splice(index, 1, res);
        this.dataSourceTests = new MatTableDataSource(this.selectedMarket.tests);
      }
    });
  }
}

/** Interface for access general market details */
interface GeneralMarket {
  marketId: string;
  listRoundingId: string;
  listVerificationId: string;
  listQuorumId: string;
  listRepetitionId: string;
  listCalculationId: string;
  currencyId: string;
  code: string;
  description: string;
  repetitionDay: number;
  quorum: number;
  hidden: boolean;
  contributionPartial: boolean;
  transactional: boolean;
  contributionStart: string;
  contributionFinish: string;
  contributionDecimalPlaces: number;
  calculationTime: string;
  calculationDecimalPlaces: number;
  dynamicSpikePeriod: number;
  minimumVolume: number;
  overrideFinish: string;
  refixTime: string;
  nextCalculation: string;
  xmlMarkup: XmlMarkup[];
  publishCalCon: boolean;
  publishRefixCon: boolean;
  instruments: Instrument[];
  tests: Test[];
  contributorIds: string[];
  disabled: boolean;
}

/** Interface for get list items for general market form */
interface MarketFormLists {
  contributorslist: ContributorListNode[];
  roundings: ValueIdPair[];
  verifications: ValueIdPair[];
  quorums: ValueIdPair[];
  repetitions: ValueIdPair[];
  calculationTypes: ValueIdPair[];
  futuresTypes: ValueIdPair[];
  forwardLookingRates: ValueIdPair[];
  currencies: ValueIdPair[];
}

/** Interface for access instrument details */
interface Instrument {
  instrumentId: string;
  listFuturesID: string;
  forwardLookingRates: string[];
  code: string;
  description: string;
  term: number;
  calculationType: ValueIdPair;
  contributionDecimalPlaces: number;
  calculationDecimalPlaces: number;
  spread: number;
  refixTolerance: number;
  spikeTolerance: number;
  d1SpikeTolerance: number;
  dynamicSpikeTolerance: number;
  dynamicSpikeToleranceBuffer: number;
  staticMovementTolerance: number;
  relativeMovementTolerance: number;
  contributionDeviationTolerance: number;
  bucketLeft: number;
  bucketRight: number;
  minimumVolume: number;
}

/** Interface for access xml markup details */
interface XmlMarkup {
  content: string;
  enabled: boolean;
}

/** Interface for access and display node list of market contributors */
interface ContributorListNode {
  name: string;
  // maticon: string;
  id?: string;
  checked?: boolean;
  children?: ContributorListNode[];
}

interface Test {
  testId: string;
  name: string;
  defaultMessage: string;
  messages: ValueIdPair[];
  enabled: boolean;
  verbose: boolean;
}
